// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__1G-Ix","inputWrap":"style_inputWrap__1nNo1","input":"style_input__2q5I9","inputCenter":"style_inputCenter__h6WZV","annotation":"style_annotation__3Diee"};